import { Breakpoint } from "ts/enums";

export const aboveXSmall = `(min-width: ${Breakpoint.SMALL}px)`;
export const aboveSmall = `(min-width: ${Breakpoint.MEDIUM}px)`;
export const aboveMedium = `(min-width: ${Breakpoint.LARGE}px)`;
export const aboveLarge = `(min-width: ${Breakpoint.XLARGE}px)`;